module.exports = __webpack_public_path__ + "static/media/h3_what_bw.eff27ce4.webp";